import { render, staticRenderFns } from "./LetterLogo.vue?vue&type=template&id=8b609544&"
import script from "./LetterLogo.vue?vue&type=script&lang=js&"
export * from "./LetterLogo.vue?vue&type=script&lang=js&"
import style0 from "./LetterLogo.vue?vue&type=style&index=0&id=8b609544&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports